import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-237db3f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Prize name")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Merchant wallet")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Game Mechanic")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Redemption Type")
], -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Momint API key")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "NFT Templates")
], -1))
const _hoisted_8 = { class: "template-list" }
const _hoisted_9 = { class: "template-list-item-number" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "NFT Redemption URL")
], -1))
const _hoisted_11 = {
  key: 3,
  class: "voucher-codes"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Voucher Codes", -1))
const _hoisted_13 = { class: "submit-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_vue_csv_errors = _resolveComponent("vue-csv-errors")!
  const _component_vue_csv_input = _resolveComponent("vue-csv-input")!
  const _component_vue_csv_map = _resolveComponent("vue-csv-map")!
  const _component_vue_csv_import = _resolveComponent("vue-csv-import")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref: "formRef",
      model: _ctx.prizeRef,
      rules: _ctx.rules
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          ref: "name",
          name: "name"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createVNode(_component_a_input, {
              type: "text",
              value: _ctx.prizeRef.name,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.prizeRef.name) = $event)),
              placeholder: "Prize name",
              class: "ant-input"
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 512),
        _createVNode(_component_a_form_item, { name: "isWinninPrize" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_checkbox, {
              checked: _ctx.prizeRef.isWinningPrize,
              "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.prizeRef.isWinningPrize) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Is winning prize")
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }),
        (_ctx.wallets.length && _ctx.prizeRef.isWinningPrize)
          ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 0,
              name: "merchant"
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_a_select, {
                  defaultValue: "Choose Merchant",
                  value: _ctx.prizeRef.redemptionWalletID,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.prizeRef.redemptionWalletID) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wallets, (wallet) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: wallet.id,
                        value: wallet.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(wallet.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form_item, { name: "gameMechanicType" }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createVNode(_component_a_select, {
              value: _ctx.prizeRef.gameMechanicType,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.prizeRef.gameMechanicType) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: "spin-to-win" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Video gameplay mechanic")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { name: "redemptionType" }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createVNode(_component_a_select, {
              value: _ctx.prizeRef.redemptionType,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.prizeRef.redemptionType) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: "scan-qr-code" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Scan QR Code")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "tap-to-redeem" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Tap to Redeem")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "voucher" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Voucher Code")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "url-voucher" }, {
                  default: _withCtx(() => [
                    _createTextVNode("URL Voucher Code")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "momint-nft" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Momint NFT")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        (_ctx.prizeRef.redemptionType == 'momint-nft')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_a_form_item, {
                ref: "apiKey",
                name: "apiKey"
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createVNode(_component_a_input, {
                    type: "text",
                    value: _ctx.prizeRef.apiKey,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.prizeRef.apiKey) = $event)),
                    placeholder: "Momint API key",
                    class: "ant-input"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 512),
              _createVNode(_component_a_form_item, {
                ref: "nftTemplateID",
                name: "nftTemplateID"
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_button, {
                      class: "template-list-button",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleAddTemplate()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Add template")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prizeRef.nftTemplates, (temp, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "template-list-item",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(`${index + 1}.`), 1),
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: temp.name,
                          "onUpdate:value": ($event: any) => ((temp.name) = $event),
                          placeholder: "Template name",
                          class: "ant-input"
                        }, null, 8, ["value", "onUpdate:value"]),
                        _createVNode(_component_a_input, {
                          type: "text",
                          value: temp.templateID,
                          "onUpdate:value": ($event: any) => ((temp.templateID) = $event),
                          placeholder: "NFT template ID",
                          class: "ant-input"
                        }, null, 8, ["value", "onUpdate:value"]),
                        _createVNode(_component_a_input_number, {
                          type: "text",
                          value: temp.count,
                          "onUpdate:value": ($event: any) => ((temp.count) = $event),
                          placeholder: "Count",
                          class: "ant-input",
                          style: {"width":"150px"}
                        }, null, 8, ["value", "onUpdate:value"]),
                        _createVNode(_component_a_button, {
                          onClick: ($event: any) => (_ctx.handleRemoveTemplate(index)),
                          type: "danger",
                          shape: "circle",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "times" })
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 512),
              _createVNode(_component_a_form_item, {
                ref: "nftURL",
                name: "nftURL"
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _createVNode(_component_a_input, {
                    type: "text",
                    value: _ctx.prizeRef.nftURL,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.prizeRef.nftURL) = $event)),
                    placeholder: "NFT Redemption URL",
                    class: "ant-input"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 512)
            ]))
          : _createCommentVNode("", true),
        (
				_ctx.prizeRef.redemptionType == 'voucher' ||
					_ctx.prizeRef.redemptionType == 'url-voucher'
			)
          ? (_openBlock(), _createBlock(_component_a_form_item, { key: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showCSVModal = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Upload voucher codes")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (
				_ctx.voucherCodes &&
					_ctx.prizeRef.id &&
					(_ctx.prizeRef.redemptionType == 'voucher' ||
						_ctx.prizeRef.redemptionType == 'url-voucher')
			)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", null, "Total:" + _toDisplayString(_ctx.voucherCodes.total), 1),
              _createElementVNode("div", null, "Remaining:" + _toDisplayString(_ctx.voucherCodes.remaining), 1),
              _createVNode(_component_a_tooltip, { title: "Delete voucher codes" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteVoucherCodesModal())),
                    shape: "circle"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: "times" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_a_button, {
                style: {"margin-right":"10px"},
                type: "default",
                onClick: _ctx.onCancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                loading: _ctx.loadingForm,
                type: "primary",
                onClick: _ctx.onSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Submit")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.showCSVModal,
      title: `Upload vouchers CSV`,
      onCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showCSVModal = false)),
      confirmLoading: _ctx.loadingVoucherCodes,
      onOk: _cache[12] || (_cache[12] = ($event: any) => (_ctx.createVouchersFromCSV()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vue_csv_import, {
          modelValue: _ctx.csvRef,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.csvRef) = $event)),
          modelModifiers: { value: true },
          fields: {
				voucher: { required: true, label: 'voucher' }
			},
          class: "upload-style"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_vue_csv_errors),
            _createVNode(_component_vue_csv_input),
            _createVNode(_component_vue_csv_map)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["visible", "confirmLoading"])
  ], 64))
}